<template>
  <div>
      <Header :itemsList="navbarData" />
      <main class="main-container">
        <slot></slot>>        
        <Footer logo="" :items="footerItems" :social="footerSocial" />
      </main>
  </div>
</template>

<script>
import Header from "@/components/templates/sections/Header.vue";
import Legales from "@/components/templates/sections/Legales.vue"
import Footer from "@/components/atoms/Footer.vue";
import DATA from "@/data/newTexts";

export default {
  name: "MainLayout",
  components: {
    Header,
    Legales,
    Footer
  },

  data() {
    return {
      footerItems: DATA.footer.items,
      footerSocial: DATA.footer.social,
      navbarData: DATA.navbarItems,
    };
  },
};
</script>
